export default "__VITE_ASSET__CBzGxuWP__"